export const ordersAndProjectsQuestions = [
  {
    id: "download",
    title: "How to download your completed translation",
    content: {
      description: "Once your project is marked Completed, you can download your translated files directly from your project dashboard. Here's how:",
      steps: [
        { text: "Go to your ", bold: "Dashboard → Projects", suffix: " tab." },
        { text: "Click the project ID of your completed translation." },
        { text: "Select ", bold: "Download certified copy", suffix: " or ", bold2: "Download all files", suffix2: "." },
        { text: "Your files will automatically download to your device." },
      ],
      tip: "If your download link expires or you encounter issues, contact your Project Manager from the Support page with your order ID.",
    },
  },
  {
    id: "new_order",
    title: "How to place a new translation order",
    content: {
      description: "Start a new translation order in just a few steps from your dashboard.",
      steps: [
        { text: "Click ", bold: "Start New Order", suffix: " on your dashboard." },
        { text: "Select your service type (", bold: "Certified", suffix: " or ", bold2: "Standard", suffix2: ")." },
        { text: "Choose ", bold: "source and target languages", suffix: "." },
        { text: "Upload your files and click ", bold: "Continue to Payment", suffix: "." },
      ],
      tip: "You'll receive a confirmation email with your order summary and estimated delivery time.",
    },
  },
  {
    id: "upload_replace",
    title: "How to upload or replace files",
    content: {
      description: "Easily upload new files or replace existing ones from your dashboard.",
      steps: [
        { text: "Open your ", bold: "Project Details", suffix: " page." },
        { text: "Click ", bold: "Upload Files", suffix: " or ", bold2: "Replace File", suffix2: "." },
        { text: "Select the file(s) from your computer or drag and drop them." },
        { text: "Wait for the upload to complete and verify it appears in your project list." },
      ],
      tip: "Accepted formats include PDF, DOCX, JPG, and PNG. Each file can be up to 25 MB.",
    },
  },
//   {
//     id: "check_progress",
//     title: "How to check project progress",
//     content: {
//       description: "Track the status of your translation project at any time.",
//       steps: [
//         { text: "Go to your ", bold: "Projects", suffix: " page." },
//         { text: "Find your project in the list." },
//         { text: "View the current status and progress indicator." },
//         { text: "Click on the project for detailed information." },
//       ],
//       tip: "You'll receive email notifications when your project status changes.",
//     },
//   },
  {
    id: "revision",
    title: "How to request a revision or correction",
    content: {
      description: "Need adjustments to your translation? Submit a revision request easily.",
      steps: [
        { text: "Go to your ", bold: "Project Details", suffix: " page." },
        { text: "Click ", bold: "Request Revision", suffix: "." },
        { text: "Describe what needs to be updated and attach supporting files if necessary." },
        { text: "Click ", bold: "Submit", suffix: " to send your request to your Project Manager." },
      ],
      tip: "You'll receive an email notification once your revision has been accepted and processing begins.",
    },
  },
];

export const billingAndPaymentsQuestions = [
  {
    id: "payment_method",
    title: "How to update your payment method",
    content: {
      description: "Keep your payment methods current to ensure smooth billing.",
      steps: [
        { text: "Go to ", bold: "Billing & Reports → Credit Cards", suffix: "." },
        { text: "Click ", bold: "Add a Card", suffix: "." },
        { text: "Enter your card details (Name, Number, ZIP)." },
        { text: "Click ", bold: "Save", suffix: " to update your payment information." },
      ],
      tip: "Languex uses Stripe for secure transactions and does not store your payment details directly.",
    },
  },
];

export const teamAndBusinessAccountsQuestions = [
  {
    id: "invite_members",
    title: "How to invite team members",
    content: {
      description: "Collaborate efficiently by inviting your team members to your business account.",
      steps: [
        { text: "Navigate to the ", bold: "Team Members", suffix: " tab." },
        { text: "Click ", bold: "Invite Team Member", suffix: "." },
        { text: "Enter their name, email, and role (Admin, Member, Viewer)." },
        { text: "Click ", bold: "Send Invite", suffix: "." },
      ],
      tip: "Admins can manage billing and permissions. Members can manage projects, while Viewers have read-only access.",
    },
  },
];

export const supportAndCommunicationQuestions = [
  {
    id: "contact_support",
    title: "How to contact support",
    content: {
      description: "Reach our team anytime for help with orders, billing, or account issues..",
      steps: [
        { text: "Open the ", bold: "Support & Help", suffix: " page in your account." },
        { text: "Select a topic (Orders, Billing, Account, etc.)." },
        { text: "Describe your request in the message box." },
        { text: "Attach files if necessary and click ", bold: "Send Request", suffix: "." },
      ],
      tip: "You can view past conversations in the Messages tab within Support & Help.",
    },
  },
];
